import { CONT_LENS, ICellCGsInfo, IContainerInformation, TGetContainersCgsResult } from "@tedivo/tedivo-bay-grid-pure";
import { ForeAftEnum, TContainerLengths } from "open-vessel-definition";
import { TContainerNameFn, TContainersSymbolsConfig } from "@tedivo/tedivo-bay-grid-core";
import { feetToMillimeters, roundDec } from "@tedivo/tedivo-pure-helpers";

export function generateSideContSymbols(
  prefixSymbol: string,
  colorUnpaired: string,
  colorPairedFwd: string,
  colorPairedAft: string,
  containersWithPositions: TGetContainersCgsResult

): TContainersSymbolsConfig<IContainerInformation> {
  const PAIRED_OPTS = [0, ForeAftEnum.FWD, ForeAftEnum.AFT];
  const colors = [colorUnpaired, colorPairedFwd, colorPairedAft];

  const containersCgsByPk = containersWithPositions.containersCgsByPk;
  const getSizeFromContainerPk = (pk: string): ICellCGsInfo | undefined => containersCgsByPk[pk];
  const getContainerInformationFromPk = (pk: string): IContainerInformation | undefined => {
    const cellInfo = getSizeFromContainerPk(pk);
    if (!cellInfo) return undefined;
    return cellInfo.meta
  }

  const nameFn: TContainerNameFn<IContainerInformation> =
    (prefixSymbol, contInfo, paired) => contInfo ? `${prefixSymbol}_${contInfo.size}-${paired}` : undefined;

  const config: TContainersSymbolsConfig<IContainerInformation> = {
    prefixSymbol,
    nameFn,
    conts: [],
    getItem: (pk: string) => getContainerInformationFromPk(pk),
    pathFn: (lengthInMM: number, heightInMM: number) =>
      `M${-lengthInMM * 0.5},${-heightInMM} h${lengthInMM} v${heightInMM} h-${lengthInMM} z`,
  };

  PAIRED_OPTS.forEach((paired) => {
    CONT_LENS.forEach((len) => {
      const name = nameFn(prefixSymbol, { size: len } as IContainerInformation, paired);
      if (!name) return;

      config.conts.push({
        name,
        lengthInMM: roundDec(feetToMillimeters(len), 0),
        heightInMM: feetToMillimeters(8.5),
        fillColor: colors[paired],
        strokeColor: colors[paired],
        fillOpacity: 0.25,
        strokeOpacity: 0.66,
        strokeWidth: 2,
        strokeDashLength: 1.5,
        dashInTheMiddle: len >= 40,
      });
    });
  });

  return config;
}
